import { render, staticRenderFns } from "./Fan_Calc.vue?vue&type=template&id=0570a3b7&"
import script from "./Fan_Calc.vue?vue&type=script&lang=js&"
export * from "./Fan_Calc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports